// src/app/utils/array.utils.ts

/**
 * Crea un array de números de una longitud específica, comenzando desde 0.
 * @param length La cantidad de elementos que debe tener el array.
 * @returns Un array de números, e.g., si length=5, devuelve [0, 1, 2, 3, 4].
 */
export function createNumberArray(length: number): number[] {

    if (length <= 0) return [];
    return Array.from({ length: length }, (_, i) => i+1);

  }